var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"add-content-page"},_vm._l((_vm.page.items),function(item,index){return _c('add-content-item',{key:`${item.type}-${index}`,attrs:{"item":item,"entity":_vm.entity},on:{"update:entity":function($event){_vm.entity=$event}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }